import {createEl} from 'shared/document'

/**
 * Downloads a blob as a file using DOM manipulation
 * @param blob - The blob to download
 * @param filename - The filename for the download
 */
export const downloadBlob = (blob: Blob, filename: string) => {
  const link = createEl('a', {
    download: filename,
    href: URL.createObjectURL(blob)
  })
  link.click()
  URL.revokeObjectURL(link.href)
}
